import { render, staticRenderFns } from "./PremiumAccountModal.vue?vue&type=template&id=7a8ed9e6&"
import script from "./PremiumAccountModal.vue?vue&type=script&lang=js&"
export * from "./PremiumAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports